<div [formGroup]="this.formGroup" class="mt-0">
    <div class="row">
        <div class="col-md-9">
            <div class="form-label">
                {{this.label}}
                <span *ngIf="this.isOptional" class="optional-tag">&nbsp;(optional)&nbsp;</span>
                <span *ngIf="this.tooltip != null">
                    <app-help-tooltip id="{{this.propertyId+'Tooltip'}}"
                        [tooltipMessage]="this.tooltip"></app-help-tooltip>
                </span>
            </div>
        </div>
        <div *ngIf="this.subText != null" class="col-md-12">
            <div [innerHTML]="this.subText"></div>
        </div>
    </div>
    <div class="container input-container mb-0">
        <div class="row mt-{{LABEL_SPACING}}">
            <div class="col-auto search-bar">
                <input id="{{this.propertyId}}" class="form-control input-box"
                    [ngClass]="(this.isInvalid()) ? 'is-invalid' : ''" type="text" maxlength={{this.maxLength}}
                    formControlName="{{this.propertyName}}" (blur)="this.userAction($event)" mask="0*">
            </div>
        </div>
        <div class="form-row align-items-center">
            <div class="col-auto mt-{{LABEL_SPACING}}">   
                <button id="clearBtn" class="btn btn-sm btn-inline btn-outline-blue business-number-button" type="button"  (click)="this.clearSearch()">Clear</button>
                <button id="searchBtn" class="btn btn-sm btn-inline btn-blue business-number-button"  type="button"  (click)="this.onSearch()" >Next</button>
            </div>
        </div>
    </div>
    <app-validator-message [formGroup]="this.formGroup" propertyName="{{this.propertyName}}"></app-validator-message>
    <div class="form-row align-items-center mt-15">
        <div class="col-md-12">            
            <div class=" databar" id="databar-grp" style="display: block;" *ngIf="this.orgBookDetails?.found === true">
                <div class="row">
                    <div class="col-md-3">
                        <span><strong>Legal name</strong></span><br>
                        <span>{{this.orgBookDetails?.legalName}}</span><br>
                    </div>
                    <div class="col-md-3" *ngIf="this.findValidJurisdiction(this.orgBookDetails?.jurisdiction) ===''">
                        <span><strong></strong></span><br>
                        <span></span>
                    </div>
                    <div class="col-md-3" *ngIf="this.findValidJurisdiction(this.orgBookDetails?.jurisdiction) !==''">
                        <span><strong>Jurisdiction</strong></span><br>
                        <span>{{this.findValidJurisdiction(this.orgBookDetails?.jurisdiction)}}</span>
                    </div>
                    <div class="col-md-2">
                        <span><strong>Incorportion date</strong></span><br>
                        <span>{{this.orgBookDetails?.incorporationDate}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <blockquote class="blockquote-border-yellow"
        *ngIf="this.orgBookDetails?.found === false && this.orgBookDetails?.isOrgBookServiceDown === false">
        <h3>Please note</h3>
        <p>The CRA business number entered is not registered with BC Registrar of Companies. If the CRA business number
            you entered is correct, you may continue with this application.</p>
    </blockquote>

    <blockquote class="blockquote-border-yellow mt-5" *ngIf="this.orgBookDetails?.isOrgBookServiceDown === true">
        <h3>Please note</h3>
        <p>The external Orgbook Service is temporarily down, please try again after some time or you can continue
            application by entering a valid BN and not clicking search</p>
    </blockquote>

    <blockquote class="blockquote-border-yellow mt-5"
        *ngIf="this.orgBookDetails?.found === true &&  this.findValidJurisdiction(this.orgBookDetails?.jurisdiction) ==='' ">
        <h3>Please note</h3>
        <p>The Jurisdiction of the CRA business number entered is not found. If the CRA business number
            you entered is correct, you may continue with this application.</p>
    </blockquote>


    <blockquote class="blockquote-border-yellow mt-5"
        *ngIf="this.orgBookDetails?.found === true && this.orgBookDetails?.entityType === 'SP' ">
        <h3>Get the right coverage</h3>
        <p>The CRA business number you provided is registered as a sole proprietorship. 
            This means you must complete the application for coverage as a sole proprietorship. 
            Please <a href="#">submit your application as a sole proprietorship.</a> </p>
        <p>If you think this is incorrect or have questions, 
            Please call our Employer Service Centre at <a
            href="tel:+16042446181">604.244.6181</a> (or toll-free at <a
            href="tel:+18889222768">1.888.922.2768</a>), Monday through Friday. 
            We'd be happy to assist you. </p>
    </blockquote>

    <div class="d-inline" *ngIf="this.showConfirmLegalNameDate()">
        <app-boolean-field label='Is the legal name and incorporation date correct?' propertyName="confirmLegalNameDate"
            [formGroup]="this.formGroup" (userInput)="handleRadioButtonClick($event)">
        </app-boolean-field>
    </div>    
</div>